/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_Meal_PrepInputs */

const en_planner_meal_prep = /** @type {(inputs: Planner_Meal_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer meal prep`)
};

const de_planner_meal_prep = /** @type {(inputs: Planner_Meal_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal-Prep bevorzugen`)
};

/**
* | output |
* | --- |
* | "Prefer meal prep" |
*
* @param {Planner_Meal_PrepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_meal_prep = /** @type {((inputs?: Planner_Meal_PrepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_Meal_PrepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_meal_prep(inputs)
	return en_planner_meal_prep(inputs)
});